import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NavBar from '../NavBar';
import { Container, Img, SkeletonLoad, Wrapper, LogoDiv } from './styles';

function Header() {
  const history = useHistory();

  const { assessoriaLogo, urlLogoSecundario, signed, page } = useSelector(
    (state: ApplicationState) => ({
      assessoriaLogo: state.config.assessoriaLogo,
      urlLogoSecundario: state.config.urlLogoSecundario,
      signed: state.auth.signed,
      page: state.auth.page,
    })
  );

  const handlerAction = (): void => {
    page !== 'contrato' && history.replace('/contrato');
  };

  return (
    <Wrapper>
      <Container>
        <LogoDiv page={page}>
          {assessoriaLogo !== '' ? (
            <Img src={assessoriaLogo} onClick={handlerAction} />
          ) : (
            <SkeletonLoad width={200} />
          )}
          {urlLogoSecundario && <Img src={urlLogoSecundario} />}
        </LogoDiv>
        {signed && <NavBar />}
      </Container>
    </Wrapper>
  );
}

export default Header;
